import React from 'react';
import { Construction } from 'lucide-react';
import { useLocation } from 'react-router-dom';

export default function PlaceholderPage() {
  const loc = useLocation();
  const name = loc.pathname.split('/').filter(Boolean).pop() || 'page';
  const label = name.charAt(0).toUpperCase() + name.slice(1);

  return (
    <div style={{
      display: 'flex', flexDirection: 'column', alignItems: 'center',
      justifyContent: 'center', minHeight: '60vh', textAlign: 'center',
    }}>
      <div style={{
        width: 72, height: 72, borderRadius: 20, marginBottom: 24,
        background: 'rgba(191,61,12,0.12)', border: '1px solid rgba(191,61,12,0.2)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
      }}>
        <Construction size={32} color="var(--or)" />
      </div>
      <h2 style={{ fontSize: 22, fontWeight: 700, color: 'var(--text)', marginBottom: 10, letterSpacing: '-0.3px' }}>
        {label} — Coming Soon
      </h2>
      <p style={{ fontSize: 14, color: 'var(--text3)', maxWidth: 360, lineHeight: 1.7, fontWeight: 300 }}>
        This section is being built. The login, auth protection, sidebar, and dashboard are fully functional — more editors are on the way.
      </p>
    </div>
  );
}
